import { Component } from '@angular/core';
import { RetailerDetailsInfoComponent } from '@src/base-components/retailers/retailer-details/retailer-details-info/retailer-details-info.component';

@Component({
    selector: 'app-retailer-details-info',
    templateUrl: '../../../../../base-components/retailers/retailer-details/retailer-details-info/retailer-details-info.component.html',
    styleUrls: ['../../../../../base-components/retailers/retailer-details/retailer-details-info/retailer-details-info.component.scss']
})

export class RetailerDetailsInfoOrisComponent extends RetailerDetailsInfoComponent { }